import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@obsn/shared/db";
import { datenbankDa, supabaseAnonKey, supabaseUrl } from "./env";
import { sitzungsSpeicher } from "./speicher";

export type Db = SupabaseClient<Database>;

/** Der einzige Supabase-Client im Browser. Liest per RLS, schreibt mit Regeln nur über RPCs (ADR-002). */
export const supabase: Db | null = datenbankDa
  ? createClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: { storage: sitzungsSpeicher, persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
    })
  : null;

export function db(): Db {
  if (!supabase) throw new Error("Keine Datenbank in dieser Umgebung.");
  return supabase;
}
